
export default function Header({ children, className }) {
    return (
        <div id="header" className={`header align-items-stretch order-1 ${className}`}>
            {children}
        </div>
    );
}